module.exports = __webpack_public_path__ + "img/電気回路_4_7_1.9d1b81c6.png";